import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";
export const linear: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-dir-lin-ka01-ha1.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-coeff-ka01-ha1.svg` },
      },
    },
  },
];
export const logarithmic: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-dir-db-ka01-ha1.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-coeff-ka01-ha1.svg` },
      },
    },
  },
];
